import { defineColumns } from '@juvare/platform-shared/features/storage';
export const columns = defineColumns({
    courseName: {
        type: 'string-required',
    },
    trainId: {
        type: 'number-required',
    },
    completionDate: {
        type: 'number-required',
    },
    accountId: {
        type: 'id-required',
    },
});
